import { render } from "./SendEmail2FAModal.vue?vue&type=template&id=838cfbfe"
import script from "./SendEmail2FAModal.vue?vue&type=script&lang=js"
export * from "./SendEmail2FAModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__